import React from "react";
import { Mic, Tv, Globe } from "lucide-react";
import { WHY_FEATURES } from "../mock";

const ICON_MAP = { Mic, Tv, Globe };

export default function WhyProducers() {
  return (
    <section className="relative py-20 md:py-32 px-4 md:px-8 overflow-hidden">
      <div className="relative max-w-7xl mx-auto">
        <div className="text-center mb-14 md:mb-20">
          <div className="text-[#f5c451] text-xs md:text-sm font-semibold tracking-[0.3em] uppercase mb-4">
            Why Choose Us
          </div>
          <h2 className="font-display text-3xl md:text-5xl lg:text-6xl text-white leading-none">
            WHY <span className="text-gold">PRODUCERS TODAY?</span>
          </h2>
          <p className="mx-auto mt-6 max-w-2xl text-white/60 text-base md:text-lg">
          Three reasons annuity producers choose us to amplify their voice, brand, and authority all at zero cost.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8">
          {WHY_FEATURES.map((f) => {
            const Icon = ICON_MAP[f.icon];
            return (
              <div
                key={f.title}
                className="premium-card card-shine rounded-md p-8 md:p-10 relative"
              >
                {/* Top row: icon + FREE pill */}
                <div className="flex items-start justify-between mb-6">
                  <div className="w-12 h-12 rounded-sm flex items-center justify-center bg-[#f5c451]/[0.08] border border-[#f5c451]/30">
                    {Icon && <Icon className="w-6 h-6 text-[#f5c451]" strokeWidth={1.8} />}
                  </div>
                  <span className="px-3 py-1 rounded-md text-[10px] tracking-[0.18em] font-bold text-[#f5c451] border border-[#f5c451]/40 bg-[#f5c451]/[0.06]">
                    FREE
                  </span>
                </div>

                <h3 className="font-display text-2xl md:text-3xl text-white mb-4 tracking-wide leading-tight">
                  {f.title}
                </h3>
                <p className="text-white/65 leading-relaxed text-sm md:text-base">
                  {f.desc}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
